import api from '../api/apiClient'
import type { Service, InitPurchaseRequest, PurchaseResponse } from '../models/service'

export const servicesRepository = {
  getAll: async (): Promise<Service[]> => {
    const response = await api.get('/services/all')
    return response.data.data
  },

  getById: async (id: number): Promise<Service> => {
    const response = await api.get(`/services/${id}`)
    return response.data.data
  },

  initPurchase: async (data: InitPurchaseRequest): Promise<PurchaseResponse> => {
    const response = await api.post('/services/init-purchase', data)
    return response.data.data
  }
}